// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__fMdFy","loading":"styles_loading__UCV1_"};